'use strict';

const jQuery = require('jquery');

module.exports.scroll = function(content) {
    if (!content.$) {
        return;
    }

    let $menu = jQuery('.cloud-nav-wrapper');
    let calcul = content.$.offset().top - (window.innerHeight / 2);

    if ($menu.hasClass('is-open')) {
        calcul = (window.innerHeight - $menu.outerHeight()) / 2;
        calcul = content.$.offset().top - calcul;
    }

    calcul = calcul + (content.$.outerHeight() / 2);

    jQuery('html, body').animate({
        'scrollTop': calcul,
    });
};
